(function () {
  'use strict';

  const root = document.querySelector('[data-demetos-pdp]');
  if (!root) return;

  const configEl = document.getElementById('demetos-pd-config');
  let config = {};
  try {
    config = JSON.parse(configEl?.textContent || '{}');
  } catch (e) {
    config = {};
  }

  let qty = 1;
  let activeImg = 0;
  let images = [];
  let onGalleryImageChange = null;
  try {
    const gEl = document.getElementById('demetos-pd-gallery');
    images = JSON.parse(gEl?.textContent || '[]');
  } catch (e) {
    images = [];
  }

  const els = {
    mainImg: root.querySelector('#demetosPdMainImg') || root.querySelector('.pd-main-img img'),
    thumbs: root.querySelector('[data-pd-thumbs]'),
    qtyVal: root.querySelectorAll('[data-pd-qty-val]'),
    buyRow: root.querySelector('[data-pd-buy-row]'),
    stickyBar: document.getElementById('demetosPdSticky'),
    cartBtns: root.querySelectorAll('[data-pd-add]'),
    decBtns: root.querySelectorAll('[data-pd-qty-dec]'),
    incBtns: root.querySelectorAll('[data-pd-qty-inc]'),
    priceBlock: document.getElementById('demetosPdPrice'),
  };

  function formatMoney(cents) {
    const n = Number(cents);
    if (!Number.isFinite(n)) return '';
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && config.moneyFormat) {
      return window.Shopify.formatMoney(n, config.moneyFormat);
    }
    return '₹' + (n / 100).toFixed(2);
  }

  function variantById(id) {
    return (config.variants || []).find((v) => Number(v.id) === Number(id));
  }

  function renderPriceBlock(v) {
    if (!els.priceBlock || !v) return;
    const price = Number(v.price);
    const compareAt = Number(v.compareAt) || 0;
    const onSale = compareAt > price;
    const pct = onSale ? Math.round(((compareAt - price) * 100) / compareAt) : 0;
    let html = '';
    if (onSale) html += '<span class="pd-price-off">-' + pct + '%</span>';
    html += '<span class="pd-price">' + formatMoney(price) + '</span>';
    if (onSale) {
      html += '<span class="pd-price-mrp">M.R.P: <s>' + formatMoney(compareAt) + '</s></span>';
    }
    html += '<span class="pd-tax">Incl. all taxes</span>';
    els.priceBlock.innerHTML = html;
    root.querySelectorAll('.pd-sticky-price').forEach((el) => {
      el.textContent = formatMoney(price);
    });
  }

  function selectVariant(id) {
    const v = variantById(id);
    if (!v) return;
    config.variantId = Number(v.id);
    config.available = v.available !== false;
    renderPriceBlock(v);
    root.querySelectorAll('[data-pd-pack-card]').forEach((btn) => {
      const active = Number(btn.dataset.variantId) === Number(v.id);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    const sel = root.querySelector('[data-pd-pack-selected]');
    if (sel) sel.textContent = v.title;
    if (els.buyRow) els.buyRow.hidden = !config.available;
    if (els.stickyBar) els.stickyBar.hidden = !config.available;
    if (v.url) window.history.replaceState({}, '', v.url);
  }

  function initPackPicker() {
    const cards = root.querySelectorAll('[data-pd-pack-card]');
    if (!cards.length) return;
    cards.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('is-disabled')) return;
        selectVariant(btn.dataset.variantId);
      });
    });
  }

  function setQty(n) {
    qty = Math.max(1, n);
    els.qtyVal.forEach((el) => {
      el.textContent = String(qty);
    });
    els.decBtns.forEach((b) => {
      b.disabled = qty <= 1;
    });
  }

  const FADE_MS = 180;
  let imgBusy = false;

  function syncThumbUi(i) {
    root.querySelectorAll('[data-pd-thumb]').forEach((btn, idx) => {
      btn.classList.toggle('active', idx === i);
    });
    const thumb = root.querySelector('[data-pd-thumb][data-index="' + i + '"]');
    if (thumb) {
      thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  function applyMainImage(i) {
    const imgEl = els.mainImg || root.querySelector('.pd-main-img img');
    if (!imgEl || !images[i]) return;
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('sizes');
    imgEl.src = images[i].src;
    imgEl.alt = images[i].alt || '';
    activeImg = i;
    syncThumbUi(i);
    onGalleryImageChange?.();
  }

  function goToImg(i, instant) {
    if (i < 0 || i >= images.length) return;
    if (i === activeImg && !instant) return;
    if (images.length < 2 && !instant) return;
    if (imgBusy && !instant) return;

    const imgEl = els.mainImg || root.querySelector('.pd-main-img img');
    if (!imgEl || !images[i]) return;

    if (instant) {
      applyMainImage(i);
      return;
    }

    imgBusy = true;
    const next = images[i];
    const preload = new Image();
    preload.src = next.src;

    imgEl.classList.add('pd-img-fade');
    window.setTimeout(() => {
      const swap = () => {
        applyMainImage(i);
        requestAnimationFrame(() => {
          imgEl.classList.remove('pd-img-fade');
          window.setTimeout(() => {
            imgBusy = false;
          }, FADE_MS);
        });
      };
      if (preload.complete) swap();
      else {
        preload.onload = swap;
        preload.onerror = swap;
      }
    }, FADE_MS);
  }

  function goImg(delta) {
    if (images.length < 2) return;
    goToImg((activeImg + delta + images.length) % images.length);
  }

  root.querySelectorAll('[data-pd-thumb]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const i = Number(btn.getAttribute('data-index'));
      if (!Number.isNaN(i)) goToImg(i);
    });
  });

  root.querySelector('[data-pd-prev]')?.addEventListener('click', () => goImg(-1));
  root.querySelector('[data-pd-next]')?.addEventListener('click', () => goImg(1));

  const lightbox = initLightbox({
    getImages: () => images,
    getActiveIndex: () => activeImg,
    goImg,
    mainImgEl: () => els.mainImg || root.querySelector('.pd-main-img img'),
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox.isOpen()) {
      lightbox.close();
      return;
    }
    if (images.length < 2) return;
    if (e.key === 'ArrowLeft') goImg(-1);
    else if (e.key === 'ArrowRight') goImg(1);
  });

  const mainWrap = root.querySelector('.pd-main-img');
  if (mainWrap && images.length > 1) {
    let touchX = 0;
    mainWrap.addEventListener('touchstart', (e) => {
      touchX = e.touches[0].clientX;
    }, { passive: true });
    mainWrap.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 50) goImg(dx > 0 ? -1 : 1);
    }, { passive: true });
  }

  els.incBtns.forEach((b) => b.addEventListener('click', () => setQty(qty + 1)));
  els.decBtns.forEach((b) => b.addEventListener('click', () => setQty(qty - 1)));

  root.querySelectorAll('[data-pd-acc-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-pd-acc]');
      if (!item) return;
      const open = item.classList.contains('open');
      root.querySelectorAll('[data-pd-acc].open').forEach((el) => el.classList.remove('open'));
      if (!open) item.classList.add('open');
    });
  });

  document.querySelectorAll('[data-pd-faq-btn]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const item = btn.closest('[data-pd-faq]');
      if (!item) return;
      const open = item.classList.contains('open');
      document.querySelectorAll('[data-pd-faq].open').forEach((el) => el.classList.remove('open'));
      if (!open) item.classList.add('open');
    });
  });

  if (els.buyRow && els.stickyBar && 'IntersectionObserver' in window) {
    const obs = new IntersectionObserver(
      ([entry]) => {
        const show = !entry.isIntersecting;
        els.stickyBar.classList.toggle('visible', show);
        document.body.classList.toggle('pd-sticky-active', show);
        document.body.classList.toggle(
          'pd-sticky-pack',
          show && els.stickyBar.classList.contains('pd-sticky-bar--pack')
        );
      },
      { threshold: 0 }
    );
    obs.observe(els.buyRow);
  }

  function initExploreScroll() {
    const explore = root.querySelector('[data-pd-explore-scroll]');
    if (!explore || explore.children.length < 2) return;
    requestAnimationFrame(() => {
      explore.scrollLeft = explore.scrollWidth / 2;
    });
    const st = { down: false, moved: false, startX: 0, startScroll: 0 };
    explore.addEventListener('mousedown', (e) => {
      st.down = true;
      st.moved = false;
      st.startX = e.pageX;
      st.startScroll = explore.scrollLeft;
    });
    window.addEventListener('mouseup', () => {
      st.down = false;
      explore.classList.remove('dragging');
    });
    explore.addEventListener('mousemove', (e) => {
      if (!st.down) return;
      const dx = e.pageX - st.startX;
      if (Math.abs(dx) > 5) {
        st.moved = true;
        explore.classList.add('dragging');
      }
      if (st.moved) explore.scrollLeft = st.startScroll - dx;
    });
    explore.addEventListener(
      'scroll',
      () => {
        const half = explore.scrollWidth / 2;
        if (explore.scrollLeft < half * 0.5) explore.scrollLeft += half;
        else if (explore.scrollLeft > half * 1.5) explore.scrollLeft -= half;
      },
      { passive: true }
    );
    explore.addEventListener(
      'click',
      (e) => {
        if (st.moved) {
          e.preventDefault();
          e.stopPropagation();
          st.moved = false;
        }
      },
      true
    );
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initExploreScroll, { timeout: 2500 });
  } else {
    setTimeout(initExploreScroll, 150);
  }

  async function addToCart(btn) {
    const variantId = Number(config.variantId);
    if (!variantId || config.available === false) return;
    const item = { id: variantId, quantity: qty };
    if (config.lineItemProperties && typeof config.lineItemProperties === 'object') {
      item.properties = config.lineItemProperties;
    }
    const items = [item];
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('loading');
    try {
      if (window.DemetosCart) {
        await window.DemetosCart.addItems(items, true);
      } else {
        const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        }).then((r) => r.json());
        if (res.status) throw new Error(res.description || 'Could not add');
        window.location.href = window.routes?.cart_url || '/cart';
        return;
      }
      btn.classList.add('added');
      const label = btn.querySelector('[data-pd-add-label]');
      if (label) label.textContent = 'Added to cart';
      setTimeout(() => {
        btn.classList.remove('added');
        if (label) label.textContent = 'Add to cart';
      }, 1800);
    } catch (err) {
      console.error('[demetos-pd]', err);
    } finally {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('loading');
    }
  }

  els.cartBtns.forEach((btn) => {
    btn.addEventListener('click', () => addToCart(btn));
  });

  setQty(1);
  initPackPicker();
  const bootImg = els.mainImg || root.querySelector('.pd-main-img img');
  if (bootImg) bootImg.classList.remove('pd-img-fade');
  activeImg = 0;
  if (images.length) syncThumbUi(0);

  function initPdTrustReveal() {
    const revealSel = '.pd-trust-sec .reveal';
    const targets = root.querySelectorAll(revealSel);
    if (!targets.length) return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -30px 0px' }
    );
    targets.forEach((el) => io.observe(el));
  }

  initPdTrustReveal();

  function initLightbox(ctx) {
    const state = {
      open: false,
      zoom: 1,
      origin: { x: 50, y: 50 },
      anim: false,
      overlay: null,
      img: null,
      touchStart: null,
      touchMoved: false,
    };

    const closeIcon =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    const arrowIconL =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>';
    const arrowIconR =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 6 15 12 9 18"/></svg>';

    function lbSrc(i) {
      const imgs = ctx.getImages();
      const item = imgs[i];
      return (item && (item.lbSrc || item.src)) || '';
    }

    function applyLbStyles() {
      if (!state.img) return;
      state.img.style.transform = 'scale(' + state.zoom + ')';
      state.img.style.transformOrigin = state.origin.x + '% ' + state.origin.y + '%';
      state.img.style.transition = state.anim ? 'transform 0.28s ease' : 'none';
      state.img.style.cursor = state.zoom > 1 ? 'zoom-out' : 'zoom-in';
      state.img.style.touchAction = state.zoom > 1 ? 'none' : 'auto';
    }

    function resetZoom() {
      state.zoom = 1;
      state.origin = { x: 50, y: 50 };
      state.anim = false;
      applyLbStyles();
    }

    function syncImage() {
      if (!state.open || !state.img) return;
      const i = ctx.getActiveIndex();
      const imgs = ctx.getImages();
      resetZoom();
      state.img.src = lbSrc(i);
      state.img.alt = (imgs[i] && imgs[i].alt) || '';
    }

    function toggleZoomAt(clientX, clientY, el) {
      if (state.zoom > 1) {
        state.anim = true;
        resetZoom();
        window.setTimeout(() => {
          state.anim = false;
        }, 300);
      } else {
        const rect = el.getBoundingClientRect();
        state.anim = true;
        state.origin = {
          x: ((clientX - rect.left) / rect.width) * 100,
          y: ((clientY - rect.top) / rect.height) * 100,
        };
        state.zoom = 2.5;
        applyLbStyles();
        window.setTimeout(() => {
          state.anim = false;
        }, 300);
      }
    }

    function moveZoomOrigin(clientX, clientY, el) {
      if (state.zoom <= 1 || state.anim) return;
      const rect = el.getBoundingClientRect();
      state.origin = {
        x: ((clientX - rect.left) / rect.width) * 100,
        y: ((clientY - rect.top) / rect.height) * 100,
      };
      applyLbStyles();
    }

    function close() {
      if (!state.open) return;
      state.open = false;
      document.body.style.overflow = '';
      resetZoom();
      state.overlay?.remove();
      state.overlay = null;
      state.img = null;
    }

    function open() {
      const imgs = ctx.getImages();
      if (!imgs.length || state.open) return;

      state.open = true;
      document.body.style.overflow = 'hidden';

      const overlay = document.createElement('div');
      overlay.className = 'pd-lightbox';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      overlay.setAttribute('aria-label', 'Product image');

      const closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'pd-lightbox-close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = closeIcon;
      closeBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        close();
      });

      const img = document.createElement('img');
      img.className = 'pd-lightbox-img';
      img.draggable = false;
      img.src = lbSrc(ctx.getActiveIndex());
      img.alt = (imgs[ctx.getActiveIndex()] && imgs[ctx.getActiveIndex()].alt) || '';
      state.img = img;
      applyLbStyles();

      img.addEventListener('click', (e) => e.stopPropagation());
      img.addEventListener('pointerup', (e) => {
        if (e.pointerType !== 'mouse') return;
        toggleZoomAt(e.clientX, e.clientY, img);
      });
      img.addEventListener('mousemove', (e) => moveZoomOrigin(e.clientX, e.clientY, img));
      img.addEventListener(
        'touchstart',
        (e) => {
          if (e.touches.length !== 1) return;
          state.touchStart = { x: e.touches[0].clientX, y: e.touches[0].clientY };
          state.touchMoved = false;
        },
        { passive: true }
      );
      img.addEventListener(
        'touchmove',
        (e) => {
          if (e.touches.length !== 1) return;
          const s = state.touchStart;
          if (s && (Math.abs(e.touches[0].clientX - s.x) > 8 || Math.abs(e.touches[0].clientY - s.y) > 8)) {
            state.touchMoved = true;
          }
          if (state.zoom <= 1) return;
          moveZoomOrigin(e.touches[0].clientX, e.touches[0].clientY, img);
        },
        { passive: true }
      );
      img.addEventListener('touchend', (e) => {
        if (state.touchMoved || !e.changedTouches[0]) return;
        const t = e.changedTouches[0];
        toggleZoomAt(t.clientX, t.clientY, img);
      });

      overlay.appendChild(closeBtn);
      overlay.appendChild(img);

      if (imgs.length > 1) {
        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'pd-lightbox-arrow pd-lightbox-arrow-l';
        prev.setAttribute('aria-label', 'Previous');
        prev.innerHTML = arrowIconL;
        prev.addEventListener('click', (e) => {
          e.stopPropagation();
          ctx.goImg(-1);
        });

        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'pd-lightbox-arrow pd-lightbox-arrow-r';
        next.setAttribute('aria-label', 'Next');
        next.innerHTML = arrowIconR;
        next.addEventListener('click', (e) => {
          e.stopPropagation();
          ctx.goImg(1);
        });

        overlay.appendChild(prev);
        overlay.appendChild(next);
      }

      overlay.addEventListener('click', () => close());
      document.body.appendChild(overlay);
      state.overlay = overlay;
    }

    const mainEl = ctx.mainImgEl();
    if (mainEl) {
      mainEl.addEventListener('click', () => open());
    }

    onGalleryImageChange = () => syncImage();

    return {
      isOpen: () => state.open,
      close,
      open,
    };
  }
})();
